(function () {
    'use strict';

    angular.module("imApp").factory("batchDelPurchLinesBService", ['$ihttp', function ($ihttp) {
        var service = {
            getBatchDelPurchLinesB: function (parms) {
                return $ihttp.post({
                    method: 2437,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2438,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();